import React from 'react';
import { lazyGettext } from '@eb/lazy-gettext';

import { Button } from '@eb/eds-button';
import { Icon } from '@eb/eds-icon';
import { SIZE_BLOCK, STYLE_LINK } from '@eb/eds-button';

import { LogoFacebookColor } from '@eb/eds-iconography';

const FacebookLogo = () => (
    <div className="facebook-button__logo eds-g-cell">
        <div className="eds-align--left">
            <Icon type={<LogoFacebookColor />} size="small" />
        </div>
    </div>
);

const ConnectedUserButton = ({
    dataAutomation,
    handleOnClick,
    firstName,
    pictureUrl,
}) => (
    <div className="facebook-button-container">
        <Button
            data-automation={dataAutomation}
            type="button"
            size={SIZE_BLOCK}
            onClick={handleOnClick}
            style={STYLE_LINK}
        >
            <div className="facebook-button__content eds-align--center">
                <FacebookLogo />

                <div className="facebook-button__text eds-g-cell">
                    {lazyGettext('Continue as %(firstName)s ', {
                        firstName,
                    })}
                </div>
                <div className="eds-g-cell facebook-button__image-wrapper">
                    <div className="eds-align--center">
                        <img
                            className="facebook-button__image"
                            src={pictureUrl}
                            alt={pictureUrl}
                        />
                    </div>
                </div>
            </div>
        </Button>
    </div>
);

const StandardButton = ({ dataAutomation, handleOnClick, buttonText }) => (
    <div className="facebook-button-container">
        <Button
            data-automation={dataAutomation}
            type="button"
            size={SIZE_BLOCK}
            onClick={handleOnClick}
            style={STYLE_LINK}
        >
            <div className="facebook-button__content eds-align--center">
                <FacebookLogo />

                <div className="facebook-button__text eds-g-cell ">
                    {buttonText}
                </div>
            </div>
        </Button>
    </div>
);

const ContinueWithFacebookButton = ({
    accessToken,
    picture,
    firstName,
    handleOnClick,
    buttonFBText,
}) => {
    let component = null;
    const dataAutomation = 'facebook-login-button';

    if (accessToken) {
        component = (
            <ConnectedUserButton
                dataAutomation={dataAutomation}
                handleOnClick={handleOnClick}
                firstName={firstName}
                pictureUrl={picture?.data?.url || ''}
            />
        );
    } else {
        const buttonText =
            buttonFBText || lazyGettext('Continue with Facebook');

        component = (
            <StandardButton
                dataAutomation={dataAutomation}
                handleOnClick={handleOnClick}
                buttonText={buttonText}
            />
        );
    }
    return component;
};

export default ContinueWithFacebookButton;
